<template>
  <input
    type="text"
    v-bind:class="{ 'input-container': true, 'right-aligned': alignRight }"
    :value="value"
    @input="onInputChange"
  />
</template>

<script>
export default {
  name: "Input",
  props: {
    alignRight: Boolean,
    onChange: Function,
    value: String
  },
  methods: {
    onInputChange(e) {
      this.onChange(e.target.value);
    }
  }
};
</script>

<style scoped>
.input-container {
  border: 1px solid #eaeaea;
  border-radius: 4px;
  box-sizing: border-box;
  height: 32px;
  width: 100%;
  padding: 0 8px;
  outline: none;
  transition: border 0.5s;
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  color: #4a4a4a;
  -webkit-appearance: none;
}
.right-aligned {
  text-align: right;
}
.input-container:hover {
  border: 1px solid rgba(8, 33, 255, 0.3);
}
.input-container:focus {
  border: 1px solid #0821ff;
}
</style>
